module.exports = __webpack_public_path__ + "static/media/whichThinnerChoice.70c987eb.mp3";